module.exports = __webpack_public_path__ + "img/overlap-notif.7ecb388b.svg";